<div class="dropdown">
  <div class="dropdown-header flex items-center justify-between bg-teal">
    <div>
      <div class="dropdown-heading cursor-pointer" (click)="test()">
        Notificações
      </div>
      <div class="dropdown-subheading" *ngIf="notifications.length > 0">
        Você possui
        {{
          notifications.length == 1
            ? "uma nova notificação."
            : notifications.length + " novas notificações."
        }}
      </div>
      <div class="dropdown-subheading" *ngIf="notifications.length == 0">
        Nenhuma notificação
      </div>
    </div>

    <button [matMenuTriggerFor]="settingsMenu" mat-icon-button type="button">
      <mat-icon
        class="notifications-header-icon"
        svgIcon="mat:settings"
      ></mat-icon>
    </button>
  </div>

  <div class="dropdown-content">
    <a
      *ngFor="let notification of notifications; trackBy: trackById"
      [routerLink]="[]"
      class="notification flex items-center"
      matRipple
      @fadeInUp
    >
      <mat-icon
        [ngClass]="notification.colorClass"
        [svgIcon]="notification.icon"
        class="notification-icon flex-none"
      ></mat-icon>
      <div class="flex-auto">
        <div class="notification-label">{{ notification.label }}</div>
        <div class="notification-description">
          {{ notification.datetime | relativeDateTime }}
        </div>
      </div>
      <div class="flex items-center gap-2">
        <div
          class="bg-teal w-2 h-2 rounded-full"
          *ngIf="!notification.read"
        ></div>

        <mat-icon
          class="notification-chevron flex-none"
          svgIcon="mat:chevron_right"
        ></mat-icon>
      </div>
    </a>
  </div>

  <div
    class="dropdown-footer flex items-center justify-center"
    *ngIf="notifications.length > 0"
  >
    <button color="primary" mat-button type="button" (click)="readAll()">
      MARCAR TUDO COMO LIDO
    </button>
  </div>
</div>

<mat-menu #settingsMenu="matMenu" xPosition="before" yPosition="below">
  <button mat-menu-item (click)="clearNotifications()">
    <mat-icon svgIcon="mat:delete_sweep"></mat-icon>
    <span>Limpar notificações</span>
  </button>

  <button mat-menu-item>
    <mat-icon svgIcon="mat:notifications_off"></mat-icon>
    <span>Desabilitar notificações</span>
  </button>
</mat-menu>
